module.exports = __webpack_public_path__ + "static/img/title-es.70c21bf0.webp";